import {
  createBrowserHistory
} from 'history';

export const HwHistory = createBrowserHistory({
  basename: '/'
});
export const HwAuthHistory = createBrowserHistory({
  basename: '/'
});